var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"my-4 py-4"},[_c('v-card-text',{staticClass:"py-0"},[_vm._t("default")],2),_c('v-row',{staticClass:"mx-0 pa-4",attrs:{"justify":"center","align":"center"}},[_c('div',{staticClass:"h5"},[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }